import { useOpenAppointmentsQuery } from '@app/queries/OpenAppointments/OpenAppointments.queries'

export const useAppointmentsTable = () => {
  const { data, loading, error } = useOpenAppointmentsQuery({
    fetchPolicy: 'network-only',
    onCompleted: () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  })

  return {
    data,
    loading,
    error
  }
}
